import { admin_routes as routes } from "../../constants/routes";
import { logout } from "../../actions/admin";
import { ProfileUtils } from "../../utils/_ProfileUtils";
import { impersonateExit } from "../../actions/admin/_ImpersonateExitAction";

const params = new URLSearchParams(window.location.search);

if (params.has("impersonate")) {
    localStorage.setItem("impersonate", params.get("impersonate"));
    window.history.replaceState(null, "", window.location.pathname);
    showImpersonate();
} else if (localStorage.getItem("impersonate")) {
    showImpersonate();
}

function showImpersonate() {
    $(".impersonate").show();
}

$(() => {
    $("body").addClass("loaded");

    const $profile_card = $(".profile_card");
    if ($profile_card.length > 0) {
        ProfileUtils.showProfileCardData("admin", $profile_card);
    }

    $("#confirm_logout_modal .btn-danger").on("click", (event) => {
        $(event.target).addClass("is_loading");

        logout()
            .then(() => {
                sessionStorage.clear();
                localStorage.clear();
                document.cookie.replace(
                    /(?<=^|;).+?(?=\=|;|$)/g,
                    (name) => location.hostname
                        .split(/\.(?=[^\.]+\.)/)
                        .reduceRight((acc, val, i, arr) => i ? arr[i]="."+val+acc : (arr[i]="", arr), "")
                        .map((domain) => document.cookie=`${name}=;max-age=0;path=/;domain=${domain}`)
                );
            })
            .then(() => {
                window.location.href = routes.login;
            }).finally(()=>{
                $(event.target).removeClass("is_loading");
            });
    });

    $(".impersonate_exit").on("click", (event)=>{
        event.preventDefault();
        impersonateExit().then(()=>{
            sessionStorage.clear();
            localStorage.clear();
            document.cookie.replace(
                /(?<=^|;).+?(?=\=|;|$)/g,
                (name) => location.hostname
                    .split(/\.(?=[^\.]+\.)/)
                    .reduceRight((acc, val, i, arr) => i ? arr[i]="."+val+acc : (arr[i]="", arr), "")
                    .map((domain) => document.cookie=`${name}=;max-age=0;path=/;domain=${domain}`)
            );
        }).then(()=>{
            const admin_location = window.location.origin;
            window.location.href= `${admin_location}/customers`;
        });
    });
});
